import { Outlet } from 'react-router-dom';

const Public = () => {
  return <Outlet />;
};

export default Public;
